import { NavLink } from 'react-router-dom';
import side from '../../css/Sidebar.module.css';

import { BsBoxSeam, BsFileEarmarkSpreadsheet } from 'react-icons/bs';
import { CiCreditCard1, CiWallet } from 'react-icons/ci';
import { FaRegQuestionCircle } from 'react-icons/fa';
import { FaRegFileImage } from 'react-icons/fa6';
import { GiPirateCoat } from 'react-icons/gi';
import { HiOutlineBanknotes, HiOutlineClipboardDocumentList } from 'react-icons/hi2';
import { IoTicketOutline } from 'react-icons/io5';
import {
  MdGavel,
  MdNotificationsNone,
  MdOutlineAccessTime,
  MdOutlinePrivacyTip,
  MdOutlineVideocam,
} from 'react-icons/md';
import { PiChats, PiOfficeChair, PiShieldCheck, PiUsersBold } from 'react-icons/pi';
import { RiContactsBook3Line, RiHome5Line, RiUser2Line } from 'react-icons/ri';
import img from '../../assest/logo.png';

const getCachedUserType = () => {
  try {
    const cached = JSON.parse(localStorage.getItem('adminData') || '{}');
    return cached?.data?.userType || cached?.userType || '';
  } catch {
    return '';
  }
};

const Sidebar = () => {
  const sidebarItems = [
    {
      name: 'Dashboard',
      icon: <RiHome5Line />,
      link: '/dashboard',
    },
    {
      name: 'Job Management',
      icon: <PiOfficeChair />,
      link: '/job-management/category',
    },
    {
      name: 'Staff Management',
      icon: <RiUser2Line />,
      link: '/staff-management/registered',
    },
    {
      name: 'User Management',
      icon: <PiUsersBold />,
      link: '/user-management',
    },
    {
      name: 'Orders',
      icon: <BsBoxSeam />,
      link: '/orders',
    },
    {
      name: 'Voucher & Offers',
      icon: <IoTicketOutline />,
      link: '/voucher-Offers',
    },
    {
      name: 'Outfit Management',
      icon: <GiPirateCoat />,
      link: '/outfit',
    },
    {
      name: 'Banner Management',
      icon: <FaRegFileImage />,
      link: '/banner-Management',
    },
    {
      name: 'Wallet Management',
      icon: <CiWallet />,
      link: '/wallet-management/user',
    },
    {
      name: 'FAQ’s',
      icon: <FaRegQuestionCircle />,
      link: '/FAQ',
    },

    {
      name: 'Chats',
      icon: <PiChats />,
      link: '/chats/user',
    },
    {
      name: 'Payments',
      icon: <CiCreditCard1 />,
      link: '/payments',
    },
    {
      name: 'Time Sheet',
      icon: <BsFileEarmarkSpreadsheet />,
      link: '/timesheet-Management',
    },
    {
      name: 'Staff Penalty',
      icon: <MdGavel />,
      link: '/staff-penalty',
    },
    {
      name: 'Contact Details',
      icon: <RiContactsBook3Line />,
      link: '/contact-details/user',
    },
    {
      name: 'Training Videos',
      icon: <MdOutlineVideocam />,
      link: '/training-videos',
    },
    {
      name: 'Send Notifications',
      icon: <MdNotificationsNone />,
      link: '/notification/send',
    },
    {
      name: 'Terms & Conditions',
      icon: <HiOutlineClipboardDocumentList />,
      link: '/termsconditions',
    },
    {
      name: 'Privacy Policy',
      icon: <MdOutlinePrivacyTip />,
      link: '/privacypolicy',
    },
    {
      name: 'Cancel Policy',
      icon: <MdOutlinePrivacyTip />,
      link: '/cancelpolicy',
    },
    {
      name: 'Sub Admin',
      icon: <PiShieldCheck />,
      link: '/sub-admin',
    },
    {
      name: 'Withdrawal Window',
      icon: <MdOutlineAccessTime />,
      link: '/withdrawal-window',
    },
    {
      name: 'Manual Payouts',
      icon: <HiOutlineBanknotes />,
      link: '/manual-payouts',
    },
  ];

  const adminOnlyLinks = ['/sub-admin', '/withdrawal-window'];
  const visibleItems =
    getCachedUserType() === 'SUB_ADMIN'
      ? sidebarItems.filter(item => !adminOnlyLinks.includes(item.link))
      : sidebarItems;

  return (
    <>
      <div className={side.sidebarcontainer}>
        <div className={side.sidelogo}>
          <div className={side.sidelogo1}>
            <img src={img} alt="" />
          </div>
        </div>
        <div className={side.sideitems}>
          {visibleItems.map(item => (
            <NavLink
              key={item.link}
              to={item.link}
              className={({ isActive }) => (isActive ? side.sideitemactive : side.sideitem)}
            >
              {item.icon}
              <p>{item.name}</p>
            </NavLink>
          ))}
        </div>
      </div>
    </>
  );
};

export default Sidebar;
